export default __webpack_public_path__ + "static/media/rain-3-day.60719041.svg";